<template>
  <v-sheet class="listCamsSetting">
    <resizable-page>
      <template #header>
        <div class="d-flex justify-space-between">
          <setting-header />
          <v-menu
            left
            offset-y
            content-class="listCamsSetting_menu"
            z-index="99"
          >
            <template #activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                text
                class="listCamsSetting_menu-btn"
                :class="{}"
                v-on="on"
              >
                <span class="icon icon-3dots" />
              </v-btn>
            </template>
            <v-list class="listCamsSetting_menu-list">
              <v-list-item @click="handleOrder">
                <v-list-item-title>
                  <img src="@/assets/img/ico_list_tile.svg" class="" alt="" />
                  <span>リスト順の編集</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="handleNew">
                <v-list-item-title>
                  <img src="@/assets/img/ico_add.svg" class="" alt="" />
                  <span>カメラグループの新規作成</span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <section
          class="listCamsSetting_actions"
          :class="{ isSorting: isSorting }"
        >
          <app-text-field
            v-if="!isSorting"
            v-model="query"
            class="listCamsSetting_search"
            color="dark"
            aria-autocomplete="off"
            autocomplete="off"
            outlined
            full-width
            :hide-details="true"
            placeholder="カメラグループの検索"
          />
          <section v-if="isSorting" class="camDetailList_actions-edit">
            <v-btn class="camDetailList_cancel" @click="cancelOrder">
              キャンセル
            </v-btn>
            <v-btn class="camDetailList_save" @click="saveOrder"> 決定 </v-btn>
          </section>
        </section>
      </template>
      <template #table="tableProps">
        <v-skeleton-loader
          v-if="loading || routeLoading"
          :loading="loading || routeLoading"
          type="table"
        ></v-skeleton-loader>
        <v-data-table
          v-else
          class="listCamsSetting_tbl"
          :height="tableProps.bodyHeight"
          :headers="computedHeaders"
          :items="tableItems"
          :fixed-header="true"
          hide-default-footer
          disable-pagination
          sort-by="dateTime"
        >
          <!-- Table header name template  -->
          <template #[`header.name`]="{ header }">
            <section class="">
              <div v-if="false">
                <v-text-field
                  v-model="movingIndex"
                  class="listCamsSetting_search listCamsSetting_moveInput"
                  color="dark"
                  aria-autocomplete="off"
                  autocomplete="off"
                  outlined
                  full-width
                  hide-details
                  placeholder=""
                >
                  <v-btn
                    slot="append"
                    width="40"
                    height="23"
                    :disabled="!movingIndex"
                    class="listCamsSetting_move"
                    @click="handleMove"
                  >
                    決定
                  </v-btn>
                </v-text-field>
              </div>
              <div
                v-else
                class="customHeader-name"
                :class="{ isSorting: isSorting }"
              >
                {{ header.text }}
              </div>
            </section>
          </template>
          <!-- Table header grabbing template  -->
          <template #[`header.grabbing`]="{ header }">
            <section class="">
              <div v-if="isSorting">
                <v-btn text class="" @click="moveSelectedItems('down')">
                  <img src="@/assets/img/ico_arrow_down.svg" class="" alt="" />
                </v-btn>
                <v-btn text class="" @click="moveSelectedItems('up')">
                  <img src="@/assets/img/ico_arrow_up.svg" class="" alt="" />
                </v-btn>
                {{ header.text }}
              </div>
            </section>
          </template>
          <!-- Table body template  -->
          <template #body="props">
            <draggable
              :list="mapRows(props.items)"
              tag="tbody"
              handle=".hamburger-menu"
              @end="dropCamRow"
            >
              <tr
                v-for="(item, index) in mapRows(props.items)"
                :key="index"
                @click="handleGroup(item)"
              >
                <td class="text-start">
                  <div class="listCamsSetting_tbl-nameWrapper">
                    <app-check
                      v-if="isSorting"
                      v-model="item.selected"
                      no-circle
                      check-index
                      :index-value="index + 1"
                    />
                    <tooltip :classes="'fixed-content'">
                      <template #activator="{ on, attrs }">
                        <div
                          v-bind="attrs"
                          class="listCamsSetting_tbl-name text-truncate"
                          style="max-width: 100%"
                          v-on="on"
                        >
                          {{ item.name }}
                        </div>
                      </template>
                      <h2>{{ item.name }}</h2>
                    </tooltip>
                  </div>
                </td>
                <td class="text-center">
                  <tooltip>
                    <template #activator="{ on, attrs }">
                      <div
                        v-bind="attrs"
                        class="listCamsSetting_tbl-registerd text-truncate"
                        style="max-width: 100%"
                        v-on="on"
                      >
                        {{ item.registerd }}
                      </div>
                    </template>
                    <h2>{{ item.registerd }}</h2>
                  </tooltip>
                </td>
                <!-- <td class="text-center">
                  <tooltip>
                    <template v-slot:activator="{ on, attrs }">
                      <div
                        v-bind="attrs"
                        class="listCamsSetting_tbl-account text-truncate"
                        style="max-width: 100%"
                        v-on="on"
                      >
                        {{ item.account }}
                      </div>
                    </template>
                    <h2>{{ item.account }}</h2>
                  </tooltip>
                </td> -->
                <td class="text-right">
                  <!-- <span v-if="isSorting" class="hamburger-menu">≡</span> -->
                </td>
              </tr>
            </draggable>
          </template>
          <!-- ----------------- -->
          <!-- Table no data -->
          <template #no-data>
            <tr style="visibility: hidden" />
          </template>
          <!-- ----------------- -->
        </v-data-table>
      </template>
    </resizable-page>
  </v-sheet>
</template>

<script>
import { MimeTypes } from '@/globals/enums';
import SettingHeader from '../SettingHeader.vue';
import { mapActions, mapState } from 'vuex';
import draggable from 'vuedraggable';
import CameraService from '@/services/CameraService';
import { AllCamerasIdGroup } from '@/globals/constants';
export default {
  name: 'ListCamsSetting',
  components: {
    SettingHeader,
    draggable,
  },
  props: {
    routeLoading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    query: null,
    mimeTypes: MimeTypes,
    selectedItems: [],
    clipToolsOpen: false,
    loading: false,
    isSorting: false,
    movingIndex: null,
    tableItems: [],
    filteredItems: [],
    isInitializing: true,
  }),
  computed: {
    ...mapState({
      groupCams: (state) => state.settings.groupCams,
      currentAvatarId: (state) => state.settings.currentAvatarId,
      isCurrentAvatarOwner: (state) => state.settings.isCurrentAvatarOwner,
    }),
    computedHeaders() {
      return [
        {
          text: '名前',
          align: 'start',
          sortable: false,
          value: 'name',
          width: '130',
          class:
            'listCamsSetting_header-name' +
            (this.isSorting ? ' isSorting' : ''),
        },
        {
          text: 'カメラ登録数',
          align: 'center',
          sortable: false,
          value: 'registerd',
          width: '150',
        },
        // {
        //   text: 'ユーザー登録数',
        //   align: 'center',
        //   sortable: false,
        //   value: 'account',
        //   width: '150',
        // },
        {
          text: '',
          align: 'right',
          sortable: false,
          width: '20',
          value: 'grabbing',
          class: 'listCamsSetting_header-grabbing',
        },
      ];
    },
  },
  watch: {
    $route(to, from) {
      this.isSorting = to.name === 'settings-cams-order';

      if (to.query.search !== from.query.search) {
        this.query = to.query.search || null;
      }
    },
    query(val) {
      if (val && val.trim() !== '') {
        const searchTerm = val.toLowerCase().trim();
        const savedCameraList = CameraService.getCameraListSetting(
          this.currentAvatarId,
          this.isCurrentAvatarOwner
        );

        if (savedCameraList && savedCameraList.length > 0) {
          this.tableItems = savedCameraList.filter((c) => {
            return c.name && c.name.toLowerCase().includes(searchTerm);
          });
        } else {
          const filteredGroups = this.groupCams.filter((c) => {
            return c.title && c.title.toLowerCase().includes(searchTerm);
          });

          this.tableItems = filteredGroups.map((g, index) => {
            return {
              index,
              id: g.id,
              name: g.title,
              registerd: g.details
                ? g.details.filter((cam) => cam.active).length
                : 0,
              account: 100,
              selected: false,
            };
          });
        }
      } else {
        this.initializeItems();
      }

      // sync with URL query parameters (only if the change came from user input, not from route change)
      // check if current route query is different to avoid infinite loops
      // skip URL updates during initialization to prevent unnecessary navigation
      if (!this.isInitializing) {
        const currentSearchParam = this.$route.query.search || null;
        const newSearchParam = val && val.trim() !== '' ? val.trim() : null;

        if (currentSearchParam !== newSearchParam) {
          const newQuery = { ...this.$route.query };
          if (newSearchParam) {
            newQuery.search = newSearchParam;
          } else {
            delete newQuery.search;
          }

          this.routerPush({
            name: this.$route.name,
            params: this.$route.params,
            query: newQuery,
          });
        }
      }
    },
  },
  mounted() {
    this.init().finally(() => {
      this.isInitializing = false;
    });
  },
  created() {
    this.currentCategory = 3;
    if (this.$route.name === 'settings-cams-order') {
      this.isSorting = true;
    }

    if (this.$route.query.search) {
      this.query = this.$route.query.search;
    }
  },
  methods: {
    ...mapActions('settings', ['fetchCameraGroup']),
    async init() {
      try {
        this.loading = true;
        await this.fetchCameraGroup({});

        this.filteredItems = this.groupCams;

        if (this.query && this.query.trim() !== '') {
          const currentQuery = this.query;
          this.query = '';
          this.$nextTick(() => {
            this.query = currentQuery;
          });
        } else {
          this.initializeItems();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    initializeItems() {
      const savedCameraList = CameraService.getCameraListSetting(
        this.currentAvatarId,
        this.isCurrentAvatarOwner
      );

      if (savedCameraList && savedCameraList.length > 0) {
        // use saved camera list with preserved order
        this.tableItems = savedCameraList;
      } else {
        // fallback to filtered items if no saved data
        this.tableItems = (this.filteredItems || []).map((g, index) => {
          return {
            index,
            id: g.id,
            name: g.title,
            registerd: g.details
              ? g.details.filter((cam) => cam.active).length
              : 0,
            account: 100,
            selected: false,
          };
        });
      }
    },
    mapRows(items) {
      return items.filter(
        (item) => !this.isSorting || item.id !== AllCamerasIdGroup
      );
    },
    handleNew() {
      this.routerPush({
        name: 'settings-cams-new',
      });
    },
    handleGroup(item) {
      if (this.isSorting) {
        item.selected = !item.selected;
        const firstSelectedItem = this.tableItems.findIndex(
          (item) => item.selected
        );
        this.movingIndex =
          firstSelectedItem > -1 ? firstSelectedItem + 1 : null;
      } else {
        this.routerPush({
          name: 'settings-cams-list-detail',
          params: {
            id: item.id,
          },
        });
      }
    },
    handleOrder() {
      this.query = null;
      this.isSorting = true;
      this.routerPush({
        name: 'settings-cams-order',
        params: this.$route.params,
        query: {},
      });
    },
    cancelOrder() {
      this.query = null;
      this.isSorting = false;
      this.movingIndex = null;
      this.initializeItems();

      this.routerPush({
        name: 'settings-cams-list',
        params: this.$route.params,
        query: {},
      });
    },
    saveOrder() {
      // Save the current order to localStorage
      const itemsToSave = this.tableItems.map((obj) => {
        return { ...obj, selected: false };
      });

      CameraService.saveCameraListSetting(
        itemsToSave,
        this.currentAvatarId,
        this.isCurrentAvatarOwner
      );

      this.query = null;
      this.isSorting = false;
      this.movingIndex = null;
      this.initializeItems();

      this.routerPush({
        name: 'settings-cams-list',
        params: this.$route.params,
        query: {},
      });
    },
    handleMove() {
      if (
        /^[1-9]\d*$/.test(this.movingIndex) &&
        +this.movingIndex <= this.tableItems.length
      ) {
        const removedObjects = [];
        const selectedItems =
          this.tableItems.filter((item) => item.selected) || [];
        if (selectedItems.length) {
          selectedItems.forEach((obj) => {
            const index = this.tableItems.findIndex(
              (item) => item.id === obj.id
            );
            if (index !== -1) {
              removedObjects.push(this.tableItems.splice(index, 1)[0]);
            }
          });
          this.tableItems.splice(+this.movingIndex - 1, 0, ...removedObjects);
        }
      }
    },
    dropCamRow(item) {
      const element = this.tableItems[item.oldIndex];
      this.tableItems.splice(item.oldIndex, 1);
      this.tableItems.splice(item.newIndex, 0, element);
    },
    handleGroupSort(desc = false) {
      this.tableItems = this.tableItems.sort((a, b) => {
        if (a.selected && !b.selected) {
          return desc ? 1 : -1;
        } else if (!a.selected && b.selected) {
          return desc ? -1 : 1;
        } else {
          return 0;
        }
      });
    },
    moveSelectedItems(direction) {
      const selected = this.tableItems.filter((item) => item.selected);
      const indices = selected.map((item) => this.tableItems.indexOf(item));
      indices.sort((a, b) => a - b);

      if (direction === 'up') {
        const firstIndex = this.tableItems.findIndex((item) => item.selected);
        if (!firstIndex) {
          return;
        }
        // prevent moving up if "All Cameras" group is directly above the first selected item
        if (
          firstIndex > 0 &&
          this.tableItems[firstIndex - 1].id === AllCamerasIdGroup
        ) {
          return;
        }
        indices.forEach((index, i) => {
          if (index > i) {
            this.tableItems.splice(
              index - 1,
              0,
              ...this.tableItems.splice(index, 1)
            );
          }
        });
      } else if (direction === 'down') {
        let lastIndex = -1;
        for (let i = 0; i < this.tableItems.length; i++) {
          if (this.tableItems[i].selected) {
            lastIndex = i;
          }
        }
        if (lastIndex === this.tableItems.length - 1) {
          return;
        }
        indices.reverse().forEach((index, i) => {
          if (index < this.tableItems.length - 1 - i) {
            this.tableItems.splice(
              index + 1,
              0,
              ...this.tableItems.splice(index, 1)
            );
          }
        });
      } else {
        throw new Error(`Invalid direction: ${direction}`);
      }
      selected.forEach((item, i) => {
        item.index = indices[i];
      });
    },
  },
};
</script>

<style lang="scss">
.listCamsSetting {
  &_actions {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    &.isSorting {
      justify-content: flex-end;
    }
  }
  &_new {
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: normal;
    text-align: left;
    border-radius: 5px;
    width: 228px;
    height: 36px;
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.16);
    &:disabled {
      color: #ccc;
      background-color: #f3f3f3;
    }
  }
  &_header {
    &-name {
      max-width: 250px;
      &.isSorting {
        padding: 0 !important;
      }
    }
    &-grabbing {
      div {
        min-width: 100px;
      }
      .v-btn {
        min-width: 0 !important;
      }
    }
  }
  &_search {
    margin-bottom: 0;
    margin-top: 0;
    padding-top: 0;
    max-width: 327px;
    &.v-input {
      font-size: 18px;
      .v-messages:not(.error--text) {
        .v-messages__message {
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.5;
          letter-spacing: normal;
          text-align: left;
        }
      }
    }
    .v-text-field__slot {
      padding-left: 0;
    }

    .v-input__slot {
      min-height: 36px !important;
      margin-bottom: 2px;
      .v-input__append-inner {
        margin-top: 9px;
      }
      .v-message__message {
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: left;
        color: #989898;
      }
    }
    &.theme--light.v-input input {
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.38;
      letter-spacing: normal;
      text-align: left;
      &:-webkit-autofill,
      &:-webkit-autofill::first-line {
        font-family: 'Noto Sans JP', sans-serif;
        font-size: 16px;
        font-weight: normal;
      }
    }

    .v-text-field__details {
      padding: 0 !important;
      padding-top: 0px !important;
      margin-bottom: 0 !important;
    }
  }
  &-infinit_scroll {
    text-align: center;
  }
  &.theme--light.v-sheet {
    border-radius: 0;
    box-shadow: none;
    padding: 0;
  }
  &_gap-header {
    height: 26px;
  }
  &_select {
    &-icon {
      width: 34px;
      height: 34px;
      padding: 5px 5px 5px 5px;
      background-color: #0075c2;
      border-radius: 50%;
      display: table-cell;
      vertical-align: middle;
      text-align: center;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
      .icon-check {
        color: #fff;
        font-size: 25px;
        font-weight: 900;
      }
    }
  }
  &_tbl {
    &.v-data-table {
      margin-top: 15px;
    }
    &-registerd,
    &-account {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: center;
      color: #4b4b4b;
    }
    .customHeader {
      &-name {
        font-size: 12px;
        font-weight: bold;
        color: #4b4b4b;
        &.isSorting {
          padding-left: 16px;
        }
      }
    }
    &-nameWrapper {
      gap: 5px;
      display: flex;
      align-items: center;
    }
    .hamburger-menu {
      cursor: grabbing;
      font-size: 24px;
      color: #989898;
      margin-right: 10px;
    }
  }
  &_move {
    &.theme--light.v-btn.v-btn--has-bg {
      font-size: 12px;
      font-weight: normal;
      line-height: 1.08;
      letter-spacing: normal;
      text-align: left;
      border-radius: 5px;
      min-width: 40px;
      height: 23px;
      background-color: #0075c2;
      color: #fff;
      box-shadow: none;
      .v-btn__content {
        line-height: unset;
      }
    }
    &:disabled {
      color: #ccc;
      background-color: #f3f3f3;
    }
    &Input {
      width: 105px;
      .v-input__append-inner {
        margin-top: 7px !important;
      }
      input {
        padding-left: 10px;
      }
    }
  }
  th {
    vertical-align: middle;
    min-width: 130px;
    span:not(.v-btn__content) {
      font-family: 'Noto Sans JP', sans-serif;
      font-size: 12px;
      font-weight: bold;
      color: #4b4b4b;
    }
  }
  td {
    vertical-align: middle;
    max-width: 75px;
    .noThumbnailImage {
      margin: 10px;
    }
  }
  tr {
    cursor: pointer;
    &.selected {
      background-color: #f4f6fc !important;
      border-color: #f4f6fc !important;
    }
  }
  &_btn {
    margin-right: 5px;
  }
  display: flex;
  flex-direction: column;
  &_subtitle {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: normal;
    text-align: left;
    color: #989898;
  }
  &_title {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 2px;
    color: var(--text-color);
    max-width: 966px;
    @media (min-width: 1280px) {
      width: calc(68vw - 339.77px);
    }
    &_text {
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #4b4b4b;
    }
    &_type {
      color: var(--warning-color-lighten1);
      font-size: 12px;
      font-weight: 600;
    }
  }
  &_videos {
    position: relative;
  }
  .v-btn {
    &:not(.v-btn--round).v-size--x-small {
      padding-left: 8px;
      padding-right: 8px;
      &.v-btn--outlined {
        padding-left: 7px;
        padding-right: 7px;
        color: #989898;
        border-color: #989898;
      }
    }
    &:not(:last-child) {
      margin-right: 8px;
    }
  }
  & .v-skeleton-loader {
    margin-top: 10px;
  }
  & .v-skeleton-loader__table-heading,
  & .v-skeleton-loader__table-tfoot {
    display: none;
  }
  &_menu {
    padding: 8px 0;
    border-radius: 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.12);
    background-color: #fff;
    &-help {
      &_label {
        display: flex;
        flex: 1;
        margin-left: 6px;
      }
    }
    &-btn {
      margin-top: 5px;
      &.v-btn:not(.v-btn--round).v-size--default {
        font-size: 16px;
        height: 31px;
        padding: 0 5px;
        min-width: 31px;
      }
      .icon {
        color: #989898;
      }
    }
    &-list.v-list {
      padding: 0;
      width: 260px;
      .v-list-item {
        min-height: 32px;
      }
      .v-list-item__title {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        color: #666;
        display: flex;
        align-items: center;
        gap: 6px;
      }
      .icon {
        font-size: 24px;
        margin-right: 6px;
        color: #989898;
      }
    }
  }
}
</style>
